export default "__VITE_ASSET__msw8Mm3z__"